import { render, staticRenderFns } from "./advice_information_details.vue?vue&type=template&id=be957834&scoped=true&"
import script from "./advice_information_details.vue?vue&type=script&lang=js&"
export * from "./advice_information_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be957834",
  null
  
)

export default component.exports